// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1QV7l","title":"ClientReferral_title__2etlo","itemText":"ClientReferral_itemText__2TxRh"};